import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { BasicMain, injectIntl } from 'components';
import { withTracker } from 'components/Tracker';
import { compose, setDisplayName } from 'recompose';
import immutableToJS from 'helpers/immutableToJS';
import { selectState } from 'redux/selectors';


class About extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    formatMessage: PropTypes.func.isRequired,
    aboutPage: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  };

  render() {
    const { formatMessage, aboutPage } = this.props;
    const title = aboutPage.length !=0 ? aboutPage[0].title : '';
    const subtitle = aboutPage.length !=0 ? aboutPage[0].subtitle : '';
    const content = aboutPage.length !=0 ? aboutPage[0].content : '';
    
    return (
      <BasicMain>
        <div className="about-page">
          <h1 className="text-center">
            { title}
          </h1>
          <h3 className="text-center mt-5">
            {subtitle}
          </h3>
          <div className="content" dangerouslySetInnerHTML={{ __html: content }}  />
          <div className="mt-5">
            {/* <p style={{ fontSize: '16px', fontWeight: 600 }}>
              <Link to="/faq">
                {formatMessage('Learn how FRESHr works')}
              </Link>
            </p> */}
            <p style={{ fontSize: '16px' }}>{formatMessage('FRESHr is free to signup and get started.')}</p>
          </div>
        </div>
      </BasicMain>
    )
  }
}


/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('options', 'aboutPage')(state),
});

export default compose(
  setDisplayName('About'),
  connect(
    mapStateToProps,
  ),
  injectIntl,
  immutableToJS,
  withTracker,
)(About);
